export default {
  LOG_LEVEL: 'debug',
  SENTRY_DSN: 'https://30045b9805f142eea65a2b2801973a4e@o140439.ingest.sentry.io/5428603',
};
